import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../../parts/crud/List'
import {ColumnType} from '../../../../parts/crud/Types'
import {useEffect, useState} from 'react'
import {processGet, processPatch} from '../../../../../services/api'
import {Form} from 'react-bootstrap'
import { set } from 'date-fns'

export const EventSubscriptionList = () => {
  const [channels, setChannels] = useState([]);
  const [analysis, setAnalysis] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      let channels: any = await processGet('system-settings/event-subscription/channel-types')
      setChannels(channels.data)

      let analysis: any = await processGet('system-settings/event-subscription/analysis-types')
      setAnalysis(analysis.data)
    }

    fetchData()
  }, [])
  const intl = useIntl()
  const columns: Array<ColumnType> = [
    //GENERIC.ACTIVE
    {
      title: intl.formatMessage({id: 'GENERIC.ACTIVE'}),
      key: 'enabled',
      type: 'custom',
      orderable: true,
      render: Checkboxes
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.EVENTS_CATEGORY'}),
      key: 'eventcat_description',
      type: 'text',
      orderable: true,
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.CHANNEL_TYPE'}),
      key: 'fk_channel',
      type: 'custom',
      orderable: true,
      render: (row) => {

        let chList: [] = row.fk_channel.split(",")
        let channelsNames: string[] = []
        for(let ch of chList){
          let channel: any = channels.find(
            (channel: any) => channel.channel_type_code === ch
          )
          if (channel) {
            channelsNames.push(channel.channel_type)
          }else{
            channelsNames.push(ch)
          }

        }
        return <>{channelsNames.join(", ")}</>
      },
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ANALYSIS_TYPE'}),
      key: 'fk_analysis',
      type: 'custom',
      orderable: true,
      render: (row) => {
        let anaysi: any = analysis.find(
          (anaysi: any) => anaysi.analysis_type_code === row.fk_analysis
        )
        if (anaysi) {
          return <>{intl.formatMessage({id:anaysi.analysis_type})}</>
        }
        return <>{row.fk_analysis}</>
      },
    },
  ]
  const [newButton, setNewButton] = useState(true)
  const [addAlert, setAddAlert] = useState(false)
  const [reloadCount, setReloadCount] = useState(0)
  useEffect(() => {
    async function getCount() {
      let data: any = await processGet('system-settings/event-subscription/count')
      if(data.data.items >= 20){
        setNewButton(false)
        setAddAlert(true)
      }else{
        setNewButton(true)
        setAddAlert(false)
      }
    }
    getCount()
  }
  , [reloadCount]);
  return (
    <>
      <CrudProvider api='system-settings/event-subscription'>
        <ListComponent
        onDeleted={() => {
          setReloadCount(reloadCount + 1)
        }}
          newButton={newButton}
          addAlert={addAlert}
          alertMessage={intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.MAX_ALERT'})}
          columns={columns}
          defOrder='eventcat_description'
          perPage={20}
          defOrderDir='asc'
          title_delete={intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.DELETE'})}
          text_eliminare={intl.formatMessage({
            id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.SURE_DELETE',
          })}
          text_eliminato={intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.DELETED'})}
          text_nuovo={intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ADD'})}
        />
      </CrudProvider>
    </>
  )
}


export const Checkboxes = (row) => {
  const [checked, setChecked] = useState(row.enabled);
  return (
    <>
      <Form>
        <Form.Check // prettier-ignore
          type='switch'
          id='custom-switch'
          checked={checked}
          onChange={(e) => {
            setChecked(e.target.checked);
            processPatch('system-settings/event-subscription/' + row.id+"/enabled", {enabled: e.target.checked?1:0})
          }}
        />
      </Form>
    </>
  )
}
